<template>
    <div :class="[{'has-danger': errors && errors.length}, extraformgroupclasses, `form-input-${type}`]">

        <div v-if="isCurrency" class="form-row">
            <div class="mui-textfield mui-textfield-flipped col" :class="{'has-suffix': suffix}">
                <label v-if="label.trim()" :for="randomId">{{ label }}</label>
                <span class="field-prefix field-prefix-text">$</span>
                <cleave
                    :autocomplete="autocompleteValue"
                    :disabled="disabled"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :size="size"
                    :id="randomId"
                    :value="cellValue"
                    @input="onInput($event)"
                    @blur="onBlur($event)"
                    :options="cleaveCurrencyInputOptions"
                    :maxlength="maxlength"
                    :class="[{'mui--is-invalid': errors && errors.length}, extraclasses]"
                    :tabindex="tabindex"
                />
                <span v-if="suffix" class="field-suffix-text">{{ suffix }}</span>
            </div>
        </div>

        <div v-if="isDecimal" class="form-row">
            <div class="mui-textfield mui-textfield-flipped col">
                <label v-if="label.trim()" :for="randomId">{{ label }}</label>
                <cleave
                    :autocomplete="autocompleteValue"
                    :disabled="disabled"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :size="size"
                    :id="randomId"
                    :value="cellValue"
                    @input="onInput($event)"
                    @blur="onBlur($event)"
                    :options="cleaveDecimalInputOptions"
                    :class="[{'mui--is-invalid': errors && errors.length}, extraclasses]"
                    :tabindex="tabindex"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Cleave from 'vue-cleave-component'

export default {
    components: {Cleave, },
    props: {
        'label': {type: String, default: ''},
        'value': {required: false},
        'errors': {required: false},
        'type': {required: true},
        'size': {required: false},
        'maxlength': {required: false},
        'extraclasses': {required: false, type: String},
        'extraformgroupclasses': {required: false},
        'placeholder': {required: false},
        'suffix': {required: false},
        'disabled': {required: false, default: false},
        'readonly': {required: false, default: false},
        'allowNegative': {required: false, default: false},
        'tabindex': {required: false, default: null},
        // Show a zero value as 0.00 rather than blank, for a zero someone entered
        'showZero': {required: false, default: false},
    },
    data() {
        return {
            randomId: 'input-' + ('' + Math.random()).substring(2),
            cleaveDecimalInputOptions: {
                numeral: true,
                numeralPositiveOnly: !this.allowNegative,
                numeralDecimalScale: 5,
            },
            cleaveCurrencyInputOptions: {
                numeral: true,
                numeralPositiveOnly: !this.allowNegative,
                numeralDecimalScale: 5,
            },
            cellValue: this.formatCellValue(this.value, this.showZero)
        }
    },
    computed: {
        isCurrency() {return this.type == 'currency-input'},
        isDecimal() {return this.type == 'decimal-input'},
        autocompleteValue() {
            return 'adsfasdfasf324' // Nonsense value to prevent the browser from attempting to autocomplete this.
        },
    },
    watch: {
        value() {
            this.cellValue = this.formatCellValue(this.value, this.showZero)
        },
        showZero() {
            this.cellValue = this.formatCellValue(this.value, this.showZero)
        },
    },
    beforeUnmount() {
        // if this input is torn down while focused, emit the pending value via blur so the edit isn't lost
        if (this.$el && this.$el.contains(document.activeElement)) {
            this.onBlur()
        }
    },
    methods: {
        formatCellValue(raw, showZero) {
            if (this.isDecimal || this.isCurrency) {
                if (raw === '' || raw == null) {
                    return ''
                }
                // Strip any thousands separators so a displayed value like "1,500" still parses
                const numeric = Number(String(raw).replace(/,/g, ''))
                if (numeric > 0 || (showZero && numeric === 0)) {
                    return numeric.toFixed(2)
                } else {
                    return ''
                }
            } else {
                return raw
            }
        },
        onInput($event) {
            if (String($event) === String(this.cellValue)) {
                return
            }
            this.cellValue = $event.target.value
            this.$emit('input', this.cellValue)
        },
        onBlur() {
            // A value typed into the input is kept even when it's zero
            this.cellValue = this.formatCellValue(this.cellValue, true)
            this.$emit('blur', this.cellValue)
        },
    },
}
</script>
